import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="min-h-[100svh] pt-4 pb-6 px-4 md:min-h-0 md:pt-24 md:pb-20 max-w-4xl mx-auto text-center flex flex-col justify-center" data-id="element-109">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-110">
        <h1 className="font-serif text-[28px] leading-[1.1] sm:text-5xl md:text-7xl font-bold text-oscuro mb-3 md:mb-7 tracking-tight" data-id="element-111">
          Resuelve un año entero de clases de yoga en solo{' '}
          <span className="italic text-salvia" data-id="element-112">5 minutos</span>
        </h1>

        <p className="text-sm sm:text-lg md:text-2xl text-gray-500 mb-4 md:mb-12 max-w-2xl mx-auto leading-snug md:leading-relaxed" data-id="element-113">
          Más de 1.200 profesoras ya dejaron de improvisar. Llega a cada clase
          con todo listo para enseñar, profundizar y transformar.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative max-w-[180px] sm:max-w-lg md:max-w-2xl mx-auto mb-4 md:mb-12" data-id="element-114">
          <img src="https://cdn.magicpatterns.com/uploads/4Qi1Y6CrCa1YvM1M5tv5SH/CON_YOGA_360_Abri_el_tomo._Imprimi._Da_la_clase._y_listo..png?width=800" srcSet="https://cdn.magicpatterns.com/uploads/4Qi1Y6CrCa1YvM1M5tv5SH/CON_YOGA_360_Abri_el_tomo._Imprimi._Da_la_clase._y_listo..png?width=400 400w, https://cdn.magicpatterns.com/uploads/4Qi1Y6CrCa1YvM1M5tv5SH/CON_YOGA_360_Abri_el_tomo._Imprimi._Da_la_clase._y_listo..png?width=800 800w, https://cdn.magicpatterns.com/uploads/4Qi1Y6CrCa1YvM1M5tv5SH/CON_YOGA_360_Abri_el_tomo._Imprimi._Da_la_clase._y_listo..png?width=1200 1200w" sizes="(max-width: 640px) 240px, (max-width: 768px) 512px, 672px" alt="Megapack YOGA 360 — Pack Anual Completo" className="w-full h-auto" width={1000} height={1200}
        // @ts-ignore
        fetchpriority="high" decoding="async" data-id="element-115" />
        </motion.div>

        <div className="flex flex-col items-center" data-id="element-116">
          <motion.a href="#elegi-tu-pack" onClick={e => {
          e.preventDefault();
          const el = document.getElementById('elegi-tu-pack');
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center bg-salvia hover:bg-salvia/90 text-white font-extrabold uppercase tracking-wide text-base sm:text-lg md:text-2xl py-3.5 md:py-6 px-8 md:px-16 rounded-full shadow-lg shadow-salvia/30 transition-colors w-full sm:w-auto mb-3 md:mb-5" data-id="element-117">
            QUIERO EL KIT YOGA 360
          </motion.a>

          <p className="text-xs md:text-base font-medium text-gray-500" data-id="element-118">
            Descarga inmediata · Sin suscripción · Acceso de por vida
          </p>
        </div>
      </motion.div>
    </section>;
}